import axios from 'axios'

export default class ServiceApi {
    constructor(api) {
        this.$api = api
    }

    findServiceOrder() {
        return axios({ url: '/service/ServiceOrder' })
    }

}



// WEBPACK FOOTER //
// ./src/api/ServiceApi.js